import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { content, contactInfo } from '../data/mock';
import './Hero.css';

const Hero = ({ language }) => {
  const t = content[language].hero;

  return (
    <section className="hero">
      <div className="container hero-grid">
        <div>
          <div className="chip">{t.chip}</div>

          <h1>{t.title}</h1>

          <p>{t.description}</p>

          <div className="hero-actions">
            <a
              className="btn btn-primary"
              href={`sms:${contactInfo.phone}?&body=${encodeURIComponent('Hi Brilliant Touch, I want a free quote')}`}
            >
              <MessageCircle size={20} />
              {t.cta1}
            </a>
            <a className="btn btn-secondary" href={`tel:${contactInfo.phone}`}>
              <Phone size={20} />
              {t.cta2}
            </a>
            <a className="btn btn-outline" href="#contact">
              {t.cta3}
            </a>
          </div>

          <div className="hero-badges">
            {t.badges.map((badge, index) => (
              <div key={index} className="badge">
                {badge}
              </div>
            ))}
          </div>
        </div>

        <div className="hero-card">
          <img src="/assets/card-front.png" alt="Brilliant Touch branded card" />
          <div className="micro-stats">
            {t.stats.map((stat, index) => (
              <div key={index}>
                <strong>{stat.label}</strong>
                <span>{stat.sublabel}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
